export default "__VITE_ASSET__a6daaf5f__"